import { CheckboxBase } from '@app/components/CheckboxBase/CheckboxBase';
import { useModelContext } from '@app/contexts/model';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IModalRejectProps {}

export const ModalReject: FunctionComponent<IModalRejectProps> = observer<FunctionComponent<IModalRejectProps>>(function () {
    const { translateStore } = useStorageTranslateContext();
    const { langFilesAcceptedModel } = useModelContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();

    let openReject = translateStore.openReject;

    const deleteFile = () => {
        return langFilesAcceptedModel
            .saveUsersTranslation({
                accept: false,
                lang: confirmTranslateStore.languageToAccept == '' ? translateStore.targetLanguageId : confirmTranslateStore.languageToAccept,
                fileId: confirmTranslateStore.fileId,
                remove: translateStore.confirmTempFilesToDelete
            })
            .then(
                (value) => {
                    return langFilesAcceptedModel.findFiles();
                },
                (reason) => {
                    return Promise.reject(reason);
                }
            );
    };

    return (
        <Dialog open={openReject} onClose={() => translateStore.handleCloseReject()} aria-describedby='alert-dialog-description'>
            <DialogContent>
                <DialogContentText variant={'h6'} mb={2} id='alert-dialog-description'>
                    Reject translation file?
                </DialogContentText>
                <CheckboxBase
                    onChange={() => {
                        translateStore.confirmTempFilesToDelete = !translateStore.confirmTempFilesToDelete;
                    }}
                    description={'Delete temporary file'}
                    value={translateStore.confirmTempFilesToDelete}
                    checked={translateStore.confirmTempFilesToDelete}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        translateStore.handleCloseReject();
                    }}
                    color='error'
                    className={'modal-buttons__no'}>
                    No
                </Button>
                <Button
                    onClick={() => {
                        deleteFile().then(
                            () => {
                                translateStore.handleCloseRejectDone();
                            },
                            (reason) => translateStore.handleOpenRejectModalError()
                        );
                    }}
                    color='primary'
                    className={'modal-buttons__yes'}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
});
